export default __webpack_public_path__ + "static/media/shrikeWord.c9609cca.svg";